<template>
	<Transition name="overlay">
		<div v-if="showing" class="loading-overlay">
			<span class="spinner" />
		</div>
	</Transition>
</template>

<script setup lang="ts">
import { ref, watch } from "vue"

const props = defineProps<{ visible: boolean }>()

const MIN_DURATION_MS = 500

const showing = ref(props.visible)
let shownAt = props.visible ? performance.now() : 0
let hideTimer: ReturnType<typeof setTimeout> | null = null

watch(
	() => props.visible,
	v => {
		if (hideTimer) {
			clearTimeout(hideTimer)
			hideTimer = null
		}
		if (v) {
			showing.value = true
			shownAt = performance.now()
		} else {
			const remaining = MIN_DURATION_MS - (performance.now() - shownAt)
			if (remaining > 0) {
				hideTimer = setTimeout(() => {
					showing.value = false
				}, remaining)
			} else {
				showing.value = false
			}
		}
	}
)
</script>

<style scoped>
.loading-overlay {
	position: absolute;
	inset: 0;
	background: rgba(255, 255, 255, 0.75);
	display: flex;
	align-items: center;
	justify-content: center;
	z-index: 10;

	.spinner {
		display: block;
		width: var(--space-32);
		height: var(--space-32);
		border: var(--border-width-base) solid var(--neutral-200);
		border-top-color: var(--neutral-600);
		border-radius: 50%;
		animation: spin 0.7s linear infinite;
	}
}

@keyframes spin {
	to {
		transform: rotate(360deg);
	}
}

.overlay-enter-active,
.overlay-leave-active {
	transition: opacity 0.2s ease;
}

.overlay-enter-from,
.overlay-leave-to {
	opacity: 0;
}
</style>
